import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import anchorScrollManager from 'Helpers/anchorScrollManager'

const usePrevious = (value) => {
  const ref = useRef()
  useEffect(() => { ref.current = value })
  return ref.current
}

export default function useLocationPathChange(action) {
  const location = useLocation()
  const prevLocation = usePrevious(location)

  useEffect(() => {
    // DO NOT REMOVE THIS. It skips action on first render to prevent a second render due to wellby's architecture.
    if (typeof prevLocation === 'undefined') {
      return
    }

    // Detect if only the hash changed (same path). If so, do not trigger the page-change action (avoids re-fetch).
    const prevPathname = prevLocation?.pathname
    const pathChanged = prevPathname !== location.pathname

    if (pathChanged) {
      action(location.pathname)
    }

    // Handle scroll behavior
    if (location.hash) {
      anchorScrollManager.scrollHashWhenAvailable()
    } else if (pathChanged) {
      // Only reset to top when the actual path changed
      try {
        window.scrollTo({ top: 0, behavior: 'auto' })
      } catch (e) {
        window.scrollTo(0, 0)
      }
    }

  }, [location]) // Re-run effect when location changes
}
